import { RouteObject } from 'react-router-dom';
import {
  CUSTOMER_REPORTS_ROUTE,
  CUSTOMER_REPORTS_ROUTES,
  PUB_REPORTS_ROUTE,
  PUB_REPORTS_ROUTES
} from 'router/routes';
import ColumnReportsV2 from 'routes/reports/ColumnReportsV2';
import {
  CustomersTab,
  PaginationTab,
  ProductsTab,
  AccountingTab,
  PublicNoticesTab
} from 'routes/reports/ColumnReportsV2/tabs';

export const reportsV2PublisherRoutes: RouteObject = {
  element: <ColumnReportsV2 />,
  children: [
    {
      path: PUB_REPORTS_ROUTE
    },
    {
      path: PUB_REPORTS_ROUTES.PUBLIC_NOTICES,
      element: <PublicNoticesTab />
    },
    {
      path: PUB_REPORTS_ROUTES.PRODUCTS,
      element: <ProductsTab />
    },
    {
      path: PUB_REPORTS_ROUTES.CUSTOMERS,
      element: <CustomersTab />
    },
    {
      path: PUB_REPORTS_ROUTES.PAGINATION,
      element: <PaginationTab />
    },
    {
      path: PUB_REPORTS_ROUTES.ACCOUNTING,
      element: <AccountingTab />
    }
  ]
};

export const reportsV2CustomerRoutes: RouteObject = {
  element: <ColumnReportsV2 />,
  children: [
    {
      path: CUSTOMER_REPORTS_ROUTE
    },
    {
      path: CUSTOMER_REPORTS_ROUTES.PRODUCTS,
      element: <ProductsTab />
    },
    {
      path: CUSTOMER_REPORTS_ROUTES.ACCOUNTING,
      element: <AccountingTab />
    }
  ]
};
